'use client'

import { saveLandingBrandDomain } from '@/lib/onboarding/landing-brand-domain'

/**
 * Stores the website the home page hero sent to `/sign-up?website=…` so
 * onboarding can prefill the brand step. It covers a submit that reached
 * sign-up as a plain form GET (before the hero's JavaScript loaded); a
 * hydrated submit has already saved it. The ref callback runs once on mount.
 */
export function LandingBrandDomainCapture({ domain }: { domain: string }) {
  function save(node: HTMLSpanElement | null) {
    if (node) {
      saveLandingBrandDomain(domain)
    }
  }

  return <span ref={save} hidden />
}
